<template>
  <div class="space-y-2">
    <BaseFormLabel>Cover</BaseFormLabel>
    <FileUpload @file-upload="updateCover">
      <template #button="{ fileUploadButtonClick }">
        <img
          v-if="cover"
          :srcset="cover.srcsets || ''"
          @load.once="onImageLoad"
          @click="fileUploadButtonClick"
          sizes="1px"
          :src="cover.url"
          class="block rounded max-w-sm w-full cursor-pointer"
        />
        <div v-else @click="fileUploadButtonClick" class="max-w-sm w-full">
          <div class="relative aspect-ratio-4/3 rounded border-2 border-dashed cursor-pointer">
            <div class="absolute inset-0 w-full h-full flex items-center justify-center">
              <div class="space-y-5 text-gray-600 flex flex-col items-center p-8">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-12 h-12 text-gray-400"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10.5 3.75a6 6 0 00-5.98 6.496A5.25 5.25 0 006.75 20.25H18a4.5 4.5 0 002.206-8.423 3.75 3.75 0 00-4.133-4.303A6.001 6.001 0 0010.5 3.75zm2.03 5.47a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.72-1.72v4.94a.75.75 0 001.5 0v-4.94l1.72 1.72a.75.75 0 101.06-1.06l-3-3z"
                    clip-rule="evenodd"
                  />
                </svg>
                <p class="text-center text-sm">
                  Drag an image here or click and browse for an image to upload.
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </FileUpload>
  </div>
</template>

<script>
import { updateProductCoverApi } from '@/api/clients/admin';
import mediableMixin from '@/mixins/mediableMixin';
import FileUpload from '@/components/Ui/FileUpload.vue';

export default {
  components: {
    FileUpload,
  },
  mixins: [mediableMixin],
  props: {
    productId: {
      type: String,
      required: true,
    },
    cover: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    updateCover({ config, data, success, error }) {
      updateProductCoverApi(this.productId, data, config)
        .then(() => {
          success();
        })
        .catch(() => {
          error();
        });
    },
  },
};
</script>
